import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client/core'
import gql from 'graphql-tag'

const httpLink = createHttpLink({
  uri: 'https://eu-central-1-shared-euc1-02.cdn.hygraph.com/content/cm0wpc88h02cq07uxfuaeo0gq/master'
})

const apolloClient = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache()
})

const query = gql`
  query Newsletters {
  newsletters {
    id
    issueNumber
    image {
      url
    }
    pdfFile {
      mimeType
      url
    }
    publishedAt
  }
}
`

export const useNewslettersStore = defineStore('Newsletters', () => {
  const newslettersData = ref([])
  const newsletters = computed(() => newslettersData)

  function init() {
    apolloClient
      .query({
        query
      })
      .then(({ data }) => {
        newslettersData.value = data.newsletters
      });
  }


  return { newsletters, init }
})
